// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphHero.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphHero.tsx");
  import.meta.hot.lastModified = "1773386009304.9773";
}
// REMIX HMR END

import clsx from "clsx";
import Button from "~/components/Button";
import Hero from "@assets/hero/octahedroid-hero.png";
import HeroMd from "@assets/hero/octahedroid-hero-md.png";
import HeroSm from "@assets/hero/octahedroid-hero-sm.png";
import { Fragment } from "react";
import Heading from "../Heading";
const SVGBackground = props => <svg width="2785" height="559" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath id="clip">
        <path d="M0 559V0h2785L0 559Z" />
      </clipPath>
    </defs>
  </svg>;
_c = SVGBackground;
export default function HeroComponent({
  text,
  title,
  cta,
  variant
}) {
  if (variant === "secondary") {
    return <section className="flex flex-col w-full items-center gap-4">
        <Heading tag="h2" className="leading-none text-center">
          {title}
        </Heading>
        <div dangerouslySetInnerHTML={{
        __html: text?.processed
      }} className="text-neutral-600 text-lg text-center max-w-[60ch]" />
        <div className="flex flex-col md:flex-row md:justify-center md:gap-4">
          {cta?.map(cta => <Button to={cta.url ? cta.url : "/"} variant="tertiary" key={cta.title}>
              {cta.title}
            </Button>)}
        </div>
      </section>;
  }
  return <Fragment>
      <SVGBackground className="hidden md:block absolute md:max-w-full" />
      <div className="[clip-path:url('#clip')] bg-gradient-primary animate-background-transition bg-400% !max-w-none hidden md:block absolute top-0 lg:top-[46px] left-0 w-full h-full"></div>
      <div className="z-10 flex md:pt-14 flex-col md:grid md:grid-cols-20 md:h-[500px] md:bg-[url('/assets/hero/octahedroid-hero.png')] bg-contain bg-no-repeat bg-right mt-14">
        <section className={clsx("flex flex-col items-start justify-center gap-4 py-8", "col-start-1 col-span-full", "md:justify-start md:pt-4 md:col-span-10 md:col-start-1 md:pr-[10%] md:pb-0")}>
          <picture className="md:hidden w-[100%] h-auto">
            <source srcSet={HeroSm} media="(max-width: 640px)" width={343} height={268} />
            <source srcSet={HeroMd} media="(max-width: 768px)" />
            <img src={Hero} alt="Hero Banner" height="766" width="980" />
          </picture>
          <Heading tag="h1" className="!text-neutral-100">{title}</Heading>
          <div dangerouslySetInnerHTML={{
          __html: text?.processed
        }} className="text-neutral-100 text-lg" />
          {cta?.map(cta => <Button to={cta.url ? cta.url : "/"} variant="tertiary" size="xl" key={cta.title}>
              {cta.title}
            </Button>)}
        </section>
      </div>
    </Fragment>;
}
_c2 = HeroComponent;
var _c, _c2;
$RefreshReg$(_c, "SVGBackground");
$RefreshReg$(_c2, "HeroComponent");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;